var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigation04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7078 8.83055C16.6507 9.76482 15.1422 17.3628 13.5942 17.4967C12.2957 17.609 11.891 15.0478 11.6175 14.2361C11.3476 13.4349 11.0472 13.1465 10.2527 12.8836C8.23415 12.2159 7.22489 11.882 7.02507 11.3533C6.49595 9.95337 14.5036 7.63731 15.7078 8.83055Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation04);
export default __webpack_public_path__ + "static/media/navigation-04.c38e53ea1a3f12df62668f87c35ee664.svg";
export { ForwardRef as ReactComponent };